import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const STORAGE_KEY = 'viver-sorrindo-faixa-etaria';
const OPEN_EVENT = 'open-age-gate';

// Reabre o portão de faixa etária a partir de qualquer lugar do app.
export function openAgeGate() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}

export default function AgeGate() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(STORAGE_KEY);
    // Só pergunta se ainda não houve escolha e o usuário não entrou
    // diretamente pela área de adultos/idosos.
    if (!choice && !location.pathname.startsWith('/adulto-idosos')) {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Permite reabrir o portão pelo botão "Trocar faixa etária"
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, handler);
    return () => window.removeEventListener(OPEN_EVENT, handler);
  }, []);

  // Bloqueia a rolagem do fundo enquanto o portão estiver aberto
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prev; };
    }
  }, [open]);

  if (!open) return null;

  const choose = (kind) => {
    localStorage.setItem(STORAGE_KEY, kind);
    setOpen(false);
    if (kind === 'adulto') {
      navigate('/adulto-idosos');
    } else {
      // menor: leva para "/" (crianças e adolescentes)
      navigate('/');
    }
  };

  return (
    <div style={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="age-gate-title">
      <div style={styles.card}>
        <div style={{ fontSize: '2.6rem', marginBottom: 8 }}>🦷</div>
        <h1 id="age-gate-title" style={styles.title}>
          Bem-vindo(a)!
        </h1>
        <p style={styles.subtitle}>
          Para mostrarmos o conteúdo mais adequado para você, nos conte a sua faixa etária:
        </p>

        <div style={styles.buttons}>
          <button
            type="button"
            style={{ ...styles.btn, ...styles.btnAdulto }}
            onClick={() => choose('adulto')}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-3px)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
          >
            <span style={{ fontSize: '1.6rem' }}>🧑</span>
            <span>Tenho 18 anos ou mais</span>
            <span style={styles.btnHint}>Adultos e idosos</span>
          </button>

          <button
            type="button"
            style={{ ...styles.btn, ...styles.btnMenor }}
            onClick={() => choose('menor')}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-3px)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
          >
            <span style={{ fontSize: '1.6rem' }}>🧒</span>
            <span>Tenho menos de 18 anos</span>
            <span style={styles.btnHint}>Crianças e adolescentes</span>
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 100000,
    background: 'rgba(1, 49, 87, 0.55)',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  card: {
    background: '#fff',
    borderRadius: 22,
    maxWidth: 560,
    width: '100%',
    padding: '36px 28px',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    fontFamily: "'Open Sans', sans-serif",
  },
  title: {
    fontFamily: "'DM Serif Display', serif",
    color: '#01579B',
    fontSize: '1.9rem',
    margin: '0 0 10px',
  },
  subtitle: {
    color: '#37474f',
    fontSize: '1rem',
    lineHeight: 1.6,
    margin: '0 auto 26px',
    maxWidth: 420,
  },
  buttons: {
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  btn: {
    flex: '1 1 200px',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    border: 'none',
    borderRadius: 16,
    padding: '22px 18px',
    cursor: 'pointer',
    color: '#fff',
    fontSize: '1.02rem',
    fontWeight: 700,
    fontFamily: "'Open Sans', sans-serif",
    transition: 'transform 0.18s ease, box-shadow 0.18s ease',
  },
  btnAdulto: {
    background: 'linear-gradient(135deg, #29B6F6 0%, #0277BD 100%)',
    boxShadow: '0 8px 20px rgba(2, 119, 189, 0.35)',
  },
  btnMenor: {
    background: 'linear-gradient(135deg, #7E57C2 0%, #5E35B1 100%)',
    boxShadow: '0 8px 20px rgba(94, 53, 177, 0.35)',
  },
  btnHint: {
    fontSize: '0.78rem',
    fontWeight: 400,
    opacity: 0.9,
  },
};
